import { AxiosError } from 'axios';
import { GraphQLResponse } from 'graphql-request/dist/types';

type ErrorMessage = {
  id: string;
  errorMessage: string;
  statusCode: number;
};

export const buildError = (error: AxiosError | Error): ErrorMessage => {
  const graphqlResponse = (error as AxiosError)?.response as GraphQLResponse;
  const graphqlErrors = graphqlResponse?.errors;
  const statusCode = graphqlResponse?.status ?? 0;

  let errorMessage = error.message || 'Unknown error';

  if (statusCode === 401) {
    errorMessage = 'Unauthorized or session expired. Sign in to view this page.';
  } else if (graphqlErrors && graphqlErrors.length > 0) {
    errorMessage = graphqlErrors.map((e) => e.message).join(' | ');
  }

  return {
    id: errorMessage,
    errorMessage,
    statusCode,
  };
};
